import { formatDocumentToApiDocument } from './document-to-api-document';

import type { PartnerApplicationContext } from '../../model/partner-application-machine';
import type { ApplicationData } from '../../model/types';

const PROOF_OF_ACCOUNT_TYPE = 'PROOF_OF_BANK_ACCOUNT' as const;

export function formatBankDetails(
  data: ApplicationData,
  values: Partial<PartnerApplicationContext>['bankDetails']
): ApplicationData {
  if (!values) return data;

  return {
    ...data,
    bankDetails: {
      providerId: values.providerId,
      beneficiaryName: values.beneficiaryName,
      accountNumber: values.accountNumber,
      proofsOfAccount: values.proofsOfAccount.map((doc) =>
        formatDocumentToApiDocument(doc, PROOF_OF_ACCOUNT_TYPE)
      ),
    },
  };
}
